import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Modal, F, PERMS, money, day, subTag } from "../lib/ui.jsx";

export default function UserDetail({ sopnoid, onClose }) {
  const { act } = useAuth();
  const [d, reload] = useLoad("user", { id: sopnoid });
  const [pk] = useLoad("packages");
  const [pt] = useLoad("portals");
  const [sub, setSub] = useState({ package_refer: "", method: "cash", trxId: "", amount: "", note: "" });
  const [perm, setPerm] = useState(null);

  const run = async (r, b, m) => {
    const x = await act(r, { sopnoid, ...b }, m);
    if (x) reload();
    return x;
  };
  const name = d?.user?.Name || "User";

  return (
    <Modal title={name} onClose={onClose} wide>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <p className="muted">{d.user.Email} - {d.user.MobileNumber} - ID {d.user.SopnoID} - joined {day(d.user.timeStamp)}</p>

            <div className="row">
              <span>Verification: <span className={"tag " + (d.state?.mail_veri == 1 ? "" : "wait")}>{d.state?.mail_veri == 1 ? "verified" : "unverified"}</span> Profile {d.state?.completion ?? 0}% complete</span>
              <span>
                {d.state?.mail_veri != 1 && (
                  <>
                    <button className="btn g s" onClick={async () => { const r = await run("resend_code", {}, "New code created."); if (r?.code) alert("New verification code: " + r.code); }}>New code</button>{" "}
                    <button className="btn s" onClick={() => run("verify_manual", {}, "Verified.")}>Verify manually</button>
                  </>
                )}
              </span>
            </div>

            <div className="row">
              <span>Account status</span>
              <select value={d.user.states} onChange={(e) => run("user_status", { states: +e.target.value }, "Status updated.")}>
                <option value={1}>Active</option><option value={0}>Suspended</option>
              </select>
            </div>
            <div className="row">
              <span>Password</span>
              <button className="btn g s" onClick={async () => { if (confirm("Reset this user's password?")) { const r = await run("user_reset_pass", {}); if (r) alert("Temporary password: " + r.temp_password); } }}>Reset password</button>
            </div>

            <h2>Activate or renew subscription</h2>
            <div className="g2">
              <div>
                <label>Package</label>
                <select value={sub.package_refer} onChange={(e) => setSub({ ...sub, package_refer: e.target.value })}>
                  <option value="">Choose package</option>
                  {pk?.rows?.filter((p) => +p.status === 1).map((p) => (
                    <option key={p.id} value={p.package_refer}>{p.gService} - {p.p_name} ({p.duration} {p.type}) {money(p.price, p.currency)}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Payment method</label>
                <select value={sub.method} onChange={(e) => setSub({ ...sub, method: e.target.value })}>
                  {["cash", "bKash", "nagad", "rocket", "bank", "admin"].map((m) => <option key={m}>{m}</option>)}
                </select>
              </div>
              <F label="Transaction ID" v={sub.trxId} set={(v) => setSub({ ...sub, trxId: v })} />
              <F label="Amount (blank = package price)" type="number" v={sub.amount} set={(v) => setSub({ ...sub, amount: v })} />
            </div>
            <div className="bar">
              <button className="btn" disabled={!sub.package_refer} onClick={async () => {
                const r = await run("subscribe", sub);
                if (r) alert(`Subscription active until ${day(r.endDate)}. Order ${r.orderId}.${r.warning ? "\n" + r.warning : ""}`);
              }}>Activate subscription</button>
            </div>

            <h2>Acquired services and payment history</h2>
            <Tbl rows={d.subs} empty="No subscriptions or payments yet." cols={[
              ["Order", (s) => s.orderId], ["Service", (s) => s.portal], ["Package", (s) => s.p_name],
              ["Paid", (s) => money(s.paid_amount, s.paid_currency)], ["Method", (s) => s.method],
              ["Period", (s) => `${day(s.startDate)} to ${day(s.endDate)}`], ["State", subTag],
              ["", (s) => (
                <button className={"btn s " + (s.status === 1 ? "d" : "g")} onClick={() => act("sub_status", { id: s.id, status: s.status === 1 ? 2 : 1 }, "Updated.").then(reload)}>
                  {s.status === 1 ? "Cancel" : "Reactivate"}
                </button>
              )],
            ]} />

            {d.settings.length > 0 && (
              <>
                <h2>Service settings</h2>
                <Tbl rows={d.settings.map((s, i) => ({ ...s, id: i }))} cols={[
                  ["Service", (s) => s.gService], ["Item", (s) => s.item || "-"], ["Value", (s) => s.item_type || "-"], ["On", (s) => (s.states == 1 ? "yes" : "no")],
                ]} />
              </>
            )}

            <h2>Portal access</h2>
            <Tbl rows={d.perms} empty="This user has no portal access." cols={[
              ["Portal", (p) => pt?.rows?.find((w) => w.portal === p.c_refer)?.name || p.c_refer],
              ["Role", (p) => p.role],
              ["Rights", (p) => PERMS.filter((k) => +p[k]).map((k) => k.slice(4)).join(", ") || "none"],
              ["", (p) => (
                <>
                  <button className="btn g s" onClick={() => setPerm({ ...p })}>Edit</button>{" "}
                  <button className="btn d s" onClick={() => confirm("Remove access to this portal?") && act("perm_delete", { id: p.id }, "Access removed.").then(reload)}>Remove</button>
                </>
              )],
            ]} />
            <div className="bar"><button className="btn g" onClick={() => setPerm({ c_refer: "", role: "user", can_view: 1 })}>Grant portal access</button></div>
            {perm && (
              <div className="box" style={{ padding: 12 }}>
                <label>Portal</label>
                <select value={perm.c_refer} disabled={!!perm.id} onChange={(e) => setPerm({ ...perm, c_refer: e.target.value })}>
                  <option value="">Choose portal</option>
                  {pt?.rows?.map((w) => <option key={w.id} value={w.portal}>{w.name} ({w.domain})</option>)}
                </select>
                <label>Role</label>
                <select value={perm.role} onChange={(e) => setPerm({ ...perm, role: e.target.value })}>
                  {["user", "manager", "admin"].map((r) => <option key={r}>{r}</option>)}
                </select>
                <div className="g2" style={{ marginTop: 8 }}>
                  {PERMS.map((k) => (
                    <label className="chk" key={k}>
                      <input type="checkbox" checked={!!+perm[k]} onChange={(e) => setPerm({ ...perm, [k]: e.target.checked ? 1 : 0 })} />
                      {k.slice(4).replace(/_/g, " ")}
                    </label>
                  ))}
                </div>
                <div className="bar">
                  <button className="btn" onClick={async () => { if (await run("perm_save", perm, "Portal access saved.")) setPerm(null); }}>Save access</button>
                  <button className="btn g" onClick={() => setPerm(null)}>Cancel</button>
                </div>
              </div>
            )}

            <h2>Recent logins</h2>
            <Tbl rows={d.logins.map((l, i) => ({ ...l, id: i }))} empty="No login records." cols={[
              ["IP", (l) => l.ip], ["In", (l) => l.in_time], ["Out", (l) => l.out_time || "-"],
            ]} />
          </>
        )}
      </Wait>
    </Modal>
  );
}
